export default __webpack_public_path__ + "static/media/demo.409e9b95.png";